(function () {
  'use strict';

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString());
  }

  /* Mobile menu */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      if (open) { nav.removeAttribute('open'); } else { nav.setAttribute('open', ''); }
    });
  });

  /* Search bar toggle */
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var bar = document.getElementById(btn.getAttribute('aria-controls'));
      if (!bar) return;
      var open = !bar.hidden;
      bar.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
      if (!open) { var i = bar.querySelector('input'); if (i) i.focus(); }
    });
  });

  /* Horizontal product scroller arrows */
  document.querySelectorAll('[data-scroller]').forEach(function (wrap) {
    var track = wrap.querySelector('.scroller');
    if (!track) return;
    wrap.querySelectorAll('[data-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.getAttribute('data-scroll') === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  });

  /* Collection filters: submit on change, mobile toggle */
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });
  document.querySelectorAll('[data-filters-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });
  document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  });

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-qty-step'), 10);
        var min = parseInt(input.min || '1', 10);
        var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Product gallery thumbnails */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.product__main-media img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.getAttribute('data-src');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.removeAttribute('sizes'); main.sizes = '(min-width: 900px) 50vw, 100vw';
        main.alt = thumb.getAttribute('data-alt') || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* Variant picker (width buttons) */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var moneyFormat = root.getAttribute('data-money-format');
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var addBtn = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var selectedLabels = root.querySelectorAll('[data-selected-value]');
    var addText = addBtn ? addBtn.getAttribute('data-add-text') : '';
    var soldText = addBtn ? addBtn.getAttribute('data-sold-text') : '';

    function currentOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts[parseInt(fs.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
      });
      return opts;
    }

    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      });
      selectedLabels.forEach(function (el) {
        var i = parseInt(el.getAttribute('data-selected-value'), 10);
        el.textContent = opts[i] || '';
      });
      if (!match) {
        if (addBtn) { addBtn.disabled = true; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price, moneyFormat);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price, moneyFormat);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        if (addLabel) addLabel.textContent = match.available ? addText : soldText;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
  });
})();
